﻿package com.milta.core.localization.translations.bg

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Моят профил",
    sectionPersonal = "Лична информация",
    labelFirstName = "Собствено име",
    labelLastName = "Фамилия",
    labelRole = "Роля",
    sectionLanguage = "Език",
    labelLanguage = "Език на приложението",
    changeLanguageButton = "Смяна на езика",
    languageDialogTitle = "Изберете вашия език",
    languageDialogConfirm = "Потвърди",
    languageDialogCancel = "Отказ",
    sectionPassword = "Сигурност",
    labelCurrentPassword = "Текуща парола",
    labelNewPassword = "Нова парола",
    changePasswordButton = "Смяна на паролата",
    successLanguageUpdated = "Езикът е обновен успешно",
    successPasswordChanged = "Паролата е сменена успешно",
    errorProfileNotFound = "Профилът не е намерен",
    errorCurrentPasswordRequired = "Моля въведете текущата си парола",
    errorCurrentPasswordTooLong = "Текущата парола не може да надвишава 128 символа",
    errorNewPasswordRequired = "Моля въведете нова парола",
    errorNewPasswordTooShort = "Новата парола трябва да съдържа поне 8 символа",
    errorNewPasswordTooLong = "Новата парола не може да надвишава 128 символа",
    errorLanguageRequired = "Моля изберете език",
    errorForbidden = "Нямате разрешение да извършите това действие",
    errorValidation = "Предоставените данни са невалидни",
    errorGeneric = "Възникна грешка. Моля опитайте отново.",
    signOut = "Изход",
    deleteAccount = "Изтриване на акаунт",
    menuLanguage = "Език на интерфейса",
    menuPassword = "Промяна на парола",
    menuSubscription = "Моят абонамент",
    menuPrivacy = "Поверителност и GDPR",
    menuTerms = "Условия за ползване",
    legalUpdatedAtPrefix = "Последна актуализация на",
    linkedCodeLabel = "Уникален код за свързване",
    linkedCodeLoadError = "Кодът за свързване не може да бъде зареден. Опитайте отново по-късно.",
    copyCode = "Копиране",
    codeCopied = "Копирано!",
    modeOrganisation = "Компания",
    modeDriver = "Шофьор",
    roleDriver = "Шофьор",
    roleOrganisation = "Компания",
    modeSwitchTitle = "Смяна на режима",
    modeSwitchHint = "Превключвайте между режим Компания и режим Шофьор по всяко време",
    switchToEnterprise = "Режим Компания",
    switchToDriver = "Режим Шофьор",
    menuPhone = "Телефонен номер",
    phoneOtpStepTitle = "Код за потвърждение, изпратен по SMS",
    successPhoneUpdated = "Телефонният номер е обновен",
    deleteAccountDialogTitle = "Да изтриете акаунта си?",
    deleteAccountDialogMessage = "Това действие е необратимо. Личната ви информация ще бъде изтрита. Код за потвърждение ще бъде изпратен по SMS.",
    deleteAccountDialogConfirm = "Продължи",
    deleteAccountOtpStepTitle = "Код за потвърждение, изпратен по SMS",
    deleteAccountConfirmButton = "Изтрий окончателно",
    errorLastEnterpriseOwner = "Вие сте единственият администратор на вашата компания. Добавете друг фирмен акаунт, преди да изтриете своя.",
    logoutPendingWarningTitle = "Неизпратени доставки",
    logoutPendingWarningMessageSuffix = "чакаща/и доставка/и ще бъдат загубени, ако излезете сега.",
    logoutPendingWarningConfirm = "Изход въпреки това",
    logoutPendingWarningCancel = "Отказ",
    modeSwitchActiveRouteWarningTitle = "Курсът е в ход",
    modeSwitchActiveRouteWarningMessage = "В момента се изпълнява курс. Смяната на режима ще ви отдалечи от проследяването му. Продължавате ли?",
    modeSwitchActiveRouteWarningConfirm = "Смени въпреки това",
    modeSwitchActiveRouteWarningCancel = "Отказ",
)

